<!-- toolbar -->
<mat-toolbar class="toolbar">
  <span class="edie-brand" routerLink="/"> {{ 'NAV.BRAND' | translate }} </span>
  <span class="spacer"></span>
  <div class="toolbar__nav">
    <ul class="flex-row align-items-center">
      <li class="login">
        <a mat-button>{{ 'NAV.LOGIN' | translate }}</a>
      </li>
      <li>
        <button mat-icon-button class="drop-menu" (click)="showMenu()">
          <mat-icon>menu</mat-icon>
        </button>
      </li>
      <li>
        <button (click)="handleLang()" mat-button class="md">
          <a [class.active-lang]="currentLang === 'de'">De</a> |
          <a [class.active-lang]="currentLang === 'en'">En</a>
        </button>
      </li>
    </ul>

    <button mat-icon-button class="side-menu" (click)="navOpen()">
      <mat-icon>menu</mat-icon>
    </button>
  </div>
</mat-toolbar>

<mat-toolbar
  class="dropdown-menu"
  [class.move-down]="dropdown"
  [class.move-up]="!dropdown"
>
  <ul>
    <li><a mat-button routerLinkActive="active" routerLink="/program">{{ 'NAV.PROGRAM' | translate }}</a></li>
    <li>
      <a
        mat-button
        routerLinkActive="active"
        href="https://moodle.bildungswerk-vielfalt.com"
        target="_blank"
      >{{ 'NAV.LEARNING_PLATFORM' | translate }}</a
      >
    </li>
    <li><a mat-button routerLinkActive="active"
           routerLink="/education">{{ 'NAV.EDUCATIONAL_COUNSELING' | translate }}</a></li>
    <li><a mat-button routerLinkActive="active" routerLink="/projects">{{ 'NAV.PROJECTS' | translate }}</a></li>
    <li><a mat-button routerLinkActive="active"
           routerLink="/demokratiewerkstatt">{{ 'NAV.DEMOCRACY_WORKSHOP' | translate }}</a></li>
    <li><a mat-button routerLinkActive="active" routerLink="/toolbox-pages">{{ 'NAV.TOOLBOX' | translate }}</a></li>
    <li><a mat-button routerLinkActive="active" (click)="getUrl()"
           routerLink="programm/archiv">{{ 'NAV.ARCHIVE' | translate }}</a></li>
    <li><a mat-button routerLinkActive="active" routerLink="/about-us">{{ 'NAV.ABOUT_US' | translate }}</a></li>
    <li>
      <button mat-icon-button (click)="closeMenu()">
        <mat-icon>highlight_off</mat-icon>
      </button>
    </li>
  </ul>
</mat-toolbar>

<div *ngIf="isAdmin()" class="admin-container">
  <mat-toolbar class="admin-nav">
    <ul (click)="showSomething()" class="nav">
      <li *ngFor="let navbarItem of navbarItems">
        <a
          [class.active]="navbarItem.selected"
          (click)="selectTab(navbarItem.id)"
          mat-button
          routerLink="{{ navbarItem.url }}"
        >
          {{ navbarItem.label | translate }}
        </a>
      </li>
      <div class="logout" (click)="logout()">
        <a mat-button>{{ 'NAV.LOGOUT' | translate }}</a>
      </div>
    </ul>
  </mat-toolbar>
</div>
